import React, { useEffect } from 'react';
import '../styles/AgeVerification.scss';

interface AgeVerificationProps {
  onConfirm: () => void;
  onReject: () => void;
}

const AgeVerification: React.FC<AgeVerificationProps> = ({ onConfirm, onReject }) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
          document.body.style.overflow = '';
        };
      }, []);

  return (
    <div className="age-verification-overlay">
      <div className="age-verification-box">
        <p>I am of legal age to purchase from this merchant.</p>
        <div className="buttons">
          <button className="confirm" onClick={onConfirm}>
            Yes, I am 18+ and above
          </button>
          <button className="reject" onClick={onReject}>
            No, I am below 18
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;
